module.exports = __webpack_public_path__ + "static/scale-model-of-room-5280---denver-live-escape-games-in-denver-colorado-dbcff2f7d8fefb725ae68f07deecd5e4.png";